export default __webpack_public_path__ + "static/media/women.0073360b.jpeg";